import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class EmployeeEmailConfigService {
    private headers = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private baseUrl = 'api/employeeEmailConfig';

    constructor(private http: Http) { }

    private extractData(res: any) {
        return res.json() || [];
    }

    getList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        return this.http.get(`${this.baseUrl}/list`, new RequestOptions({ headers: this.headers, search: params }))
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addUpdate(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/addUpdate`, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    delete(emp_email_id: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/delete`, $.param({ emp_email_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    uploadExcel(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/uploadExcel`, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json())
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('EmployeeEmailConfigService error', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/employeeEmailConfig.service.ts